// routes/error.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/error')

export const handle = { name: 'error' }

export default dynamic(getClientModule, { ssr: false })
